import { FC, ReactNode } from 'react'

import { useQuery } from '@tanstack/react-query'
import { getRouteApi } from '@tanstack/react-router'
import { clientUsersListQueryOptions } from '~bank-client-users/service/clientUsersListQueryOptions'
import { ClientUsersListFilterParams } from '~bank-client-users/types'

import { ClientUsersListContext } from './ClientUsersListContext'

type ClientUsersListProviderProps = {
  children: ReactNode
}

export const ClientUsersListContextProvider: FC<ClientUsersListProviderProps> = ({
  children
}: ClientUsersListProviderProps) => {
  const routeApi = getRouteApi('/_app/client-users/')

  const search = routeApi.useSearch()
  const navigate = routeApi.useNavigate()

  const clientUsersListQuery = useQuery(clientUsersListQueryOptions(search))

  if (!clientUsersListQuery.data) return null

  const value = {
    data: clientUsersListQuery.data,
    isPending: clientUsersListQuery.isLoading || clientUsersListQuery.isRefetching,
    successFullyLoaded: !!clientUsersListQuery.data,
    state: { ...clientUsersListQuery.data?.form, ...search },
    navigate: (searchParams: Partial<ClientUsersListFilterParams>) =>
      navigate({ to: '.', search: (prev) => ({ ...prev, ...searchParams }), resetScroll: false, replace: true }),
    clear: () => navigate({ to: '.', search: undefined, resetScroll: false, replace: true })
  }

  return <ClientUsersListContext.Provider value={value}>{children}</ClientUsersListContext.Provider>
}
